// 认证相关工具函数

/**
 * 检查用户是否已登录
 * @returns {boolean}
 */
export function isLoggedIn() {
  return localStorage.getItem('isLoggedIn') === 'true'
}

/**
 * 获取当前登录用户名
 * @returns {string|null}
 */
export function getCurrentUser() {
  return localStorage.getItem('username')
}

/**
 * 获取登录时间
 * @returns {string|null}
 */
export function getLoginTime() {
  return localStorage.getItem('loginTime')
}

/**
 * 登出用户
 */
export function logout() {
  localStorage.removeItem('isLoggedIn')
  localStorage.removeItem('username')
  localStorage.removeItem('loginTime')
}

/**
 * 检查登录是否过期（可选功能，这里设置为24小时）
 * @returns {boolean}
 */
export function isLoginExpired() {
  const loginTime = getLoginTime()
  if (!loginTime) return true
  
  const loginDate = new Date(loginTime)
  const now = new Date()
  const diffHours = (now - loginDate) / (1000 * 60 * 60)
  
  // 24小时后过期
  return diffHours > 24
}

/**
 * 验证用户权限（目前只有一个管理员角色）
 * @returns {boolean}
 */
export function hasPermission() {
  return isLoggedIn() && !isLoginExpired()
}